import type { DataChartStyleProps } from './datachartStyleRegistry'
import { EnergyChartThreePhaseBase } from './EnergyChartThreePhaseBase'

export function EnergyChartStyle04(props: DataChartStyleProps) {
  return <EnergyChartThreePhaseBase variant="gold" chartType="bar" {...props} />
}
